import { render } from "./TSAMenuBar.vue?vue&type=template&id=7cb03974"
import script from "./TSAMenuBar.vue?vue&type=script&lang=js"
export * from "./TSAMenuBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__